<template>
  <div>
    <div v-if="!pod">
      File not found!
    </div>
    <div v-if="pod">
      <div>
        <h1>{{ $t('routes.pod.menuInfo.mediaInformation') }}</h1>
      </div>

      <v-tabs v-if="canShowMetadata" color="primary" bg-color="active" v-model="mediaInformation" fixed-tabs>
        <v-tab value="file">{{ $t('routes.pod.file') }}</v-tab>
        <v-tab value="metadata">{{ $t('routes.pod.metadata') }}</v-tab>
      </v-tabs>

      <v-tabs-window v-if="canShowMetadata" v-model="mediaInformation">
        <v-tabs-window-item value="file">
          <MediaInformationNote
            :pod="pod"
            :disable-notes="disableNotes"
            :standalone="false"
          />
        </v-tabs-window-item>
        <v-tabs-window-item value="metadata">
          <div class="metadata-wrapper">
            <MediaMetadata :metadata="metadata"/>
          </div>
        </v-tabs-window-item>
      </v-tabs-window>

      <MediaInformationNote
        v-if="!canShowMetadata"
        :pod="pod"
        :disable-notes="disableNotes"
        :standalone="true"
      />
    </div>
  </div>
</template>

<script>
import MediaInformationNote from './MediaInformationNote.vue';
import MediaMetadata from '@/layouts2/mainLayout/components/podSidemenu/informationToolbar/MediaMetadata.vue';

export default {
  name: 'InformationToolbar',
  components: { MediaMetadata, MediaInformationNote },
  props: {
    pod: Object,
    disableNotes: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      mediaInformation: 'file',
    };
  },
  computed: {
    canShowMetadata: function () {
      return this.rawAsset?.mimetype.startsWith('image/') && this.metadata !== null;
    },
    rawAsset: function () {
      if (this.pod.asset && this.pod.asset.raw && this.pod.asset.raw[0]) {
        return this.pod.asset.raw[0];
      }

      return null;
    },
    metadata: function () {
      if (this.rawAsset.metadata) {
        if (typeof this.rawAsset.metadata == 'string') {
          return JSON.parse(this.rawAsset.metadata);
        }

        return this.rawAsset.metadata;
      }

      return null;
    },
  },
};
</script>

<style lang="scss">
.pod-information-section {
  padding: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: rgb(var(--v-theme-tw-surface-accent));

  &-standalone {
    @extend .pod-information-section;

    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &-row {
    width: 100%;

    & > div {
      width: 50%;
      white-space: wrap;
      overflow: hidden;
      text-overflow: ellipsis;
      overflow-wrap: break-word;
    }

    & > div:first-child {
      font-weight: 600;
    }

    & > div:nth-child(2) {
      margin-left: 5px;
    }
  }

  &-category {
    &:not(:first-child) {
      border-top: 1px solid var(--tw-fg-color-active);
      margin-top: 1rem
    }

    &-title {
      width: 100%;
      font-weight: 600;
      margin: 8px 0;
      font-size: 1.25rem;
      font-style: italic;
    }
  }
}
</style>
